module.exports = __webpack_public_path__ + "img/logo-icon.f0330fee.png";